<h2 mat-dialog-title class="text-lg font-bold mb-1">Viajes de vehículo {{ data.vehicleName }}</h2>

<mat-dialog-content class="modal-content">
  @if (dataSource.length === 0) {
    <div class="flex flex-col items-center justify-center p-8 text-gray-500">
      <mat-icon class="!text-5xl !w-12 !h-12 mb-2">directions_car</mat-icon>
      <p>Este vehículo no tiene viajes activos</p>
    </div>
  } @else {
    <div class="overflow-auto max-h-96">
      <table mat-table [dataSource]="dataSource" class="w-full table-trips">

        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="text-left" style="min-width: 50px;">Viaje</th>
          <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase" style="min-width: 50px;">
            @if (hasTrip(element)) {
              <app-trip-navigation
                [trip]="{ _id: element._id, id: element.id }"
                displayMode="id"
                [showIcon]="true"
                [openInNewTab]="true"
              />
            } @else {
              <span>-</span>
            }
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="text-center" style="min-width: 90px;">Estado</th>
          <td mat-cell *matCellDef="let element" class="text-center" style="min-width: 90px;">
            @if (element.statusTripId) {
              <app-trip-status-badge [statusTripId]="element.statusTripId"></app-trip-status-badge>
            } @else {
              <span class="text-gray-400">-</span>
            }
          </td>
        </ng-container>

        <!-- SubRoute Column -->
        <ng-container matColumnDef="subRoute">
          <th mat-header-cell *matHeaderCellDef class="text-left" style="padding-right: 10px;">Ruta</th>
          <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase" style="padding-right: 10px;">
            <app-sub-route-navigation
              [route]="{ routeCode: element.subRouteCode, routeName: element.nameSubRoute }"
              displayMode="both"
              [showIcon]="true"
              interactionMode="icon-only"
              [openInNewTab]="true"
            />
          </td>
        </ng-container>

        <!-- Territorios Column -->
        <ng-container matColumnDef="territory">
          <th mat-header-cell *matHeaderCellDef class="font-semibold" style="min-width: 90px;">Territorios</th>
          <td mat-cell *matCellDef="let element" style="min-width: 90px;">
            <div class="text-sm">
              @if (getTerritoriesTrips(element).length > 0) {
                <div class="flex flex-wrap gap-1">
                  @for (territory of visibleTerritories(element); track territory._id) {
                    <span class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800">
                      <mat-icon class="!w-3 !h-3 !text-[12px]">location_on</mat-icon>
                      <span class="truncate">{{ territory.externalKeys?.code ? (territory.externalKeys.code + ' - ' + territory.name) : territory.name }}</span>
                      <app-route-navigation
                        [route]="territory"
                        [showText]="false"
                        [showIcon]="true"
                        interactionMode="icon-only"
                        [openInNewTab]="true"
                      />
                    </span>
                  }
                  @if (hiddenTerritoriesCount(element) > 0) {
                    <span class="inline-flex items-center px-2 py-1 rounded-full text-xs bg-purple-100 text-purple-800">
                      +{{ hiddenTerritoriesCount(element) }}
                    </span>
                  }
                </div>
              } @else {
                <span class="text-gray-400">Sin territorios</span>
              }
            </div>
          </td>
        </ng-container>

        <!-- Function Column -->
        <ng-container matColumnDef="function">
          <th mat-header-cell *matHeaderCellDef class="text-left" style="min-width: 80px;">Función</th>
          <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase" style="min-width: 80px;">
            <div class="flex flex-col">
              <b class="text-[10px]">{{ element.functionCode }}</b>
              <span>{{ element.function }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef class="text-left" style="min-width: 130px;">Fecha Teórica</th>
          <td mat-cell *matCellDef="let element" class="text-left" style="min-width: 130px;">
            <p class="text-sm" style="min-width: 102px;">
              <span class="text-[10px]">
                FI: {{ element?.dateHourStartTeoric | FormatDateHour: false }}<br>
                FF: {{ element?.dateHourEndTeoric | FormatDateHour: false }}
              </span>
            </p>
          </td>
        </ng-container>

        <!-- User Column -->
        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef class="text-left">Responsable</th>
          <td mat-cell *matCellDef="let element" class="leading-tight text-sm uppercase">
            <app-business-partner-navigation
              [businessPartner]="{ code: element.assignedUserCode, name: element.assignedUser }"
              displayMode="both"
              [showIcon]="true"
              interactionMode="icon-only"
              [openInNewTab]="true"
            />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="bg-gray-50"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
      </table>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
